<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <AuditLog></AuditLog>
            </v-flex xs12>
        </v-layout>
    </v-container>
</template>

<script>
import AuditLog from "./AuditLog.vue";

export default {
    components: {
        AuditLog
    },
    props: [
        
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        
    }
};
</script>

<style>

</style>